// extracted by mini-css-extract-plugin
export default {"Container":"Poster_Container__MOFJB","wrapper":"Poster_wrapper__OP1IU","poster_1":"Poster_poster_1__UXFqh"};